const atomic = require('../../../git_modules/@tomandco/atomic/config/color');

/**
 * Not all colors are used to generate atomic classes
 *
 * Use named colors in SCSS files by `get` function
 * @example
 * ```css
 *   .class {
 *     color: get('namedColor.abbey');
 *   }
 * ```
 */
const namedColor = {
    midnight: '#0F112F',
    navy: '#004891',
    lightNavy: '#849BEB',
    red: '#E8291C',
    green: '#008000',
    lines: '#BDC0CA',
    background: '#E2E4E9',
    lightBackground: '#F2F3F7',
    ice: '#EFF8FA',
    aqua: '#4FC4CA',
    aquaGradient: 'linear-gradient(93.09deg, #4FC4CA 3.18%, #0D9CAB 79.45%)',
    yellow: '#FDB714',
    yellowTint: '#FED881',
    white: '#FFFFFF'
};
exports.namedColor = namedColor;

/**
 * Those colors are used to generate atomic classes.
 *
 * WARNING!!! `key` and `value` are required.
 * Other are used in iCMS
 *
 * @example
 * ```css
 *   .col-1 { color: #454647; }
 * ```
 */
const color = [
    { key: '1', value: namedColor.midnight, title: 'Midnight', group: 'Primary' },
    { key: '11', value: namedColor.navy, title: 'Navy', group: 'Primary' },
    { key: '12', value: namedColor.lightNavy, title: 'Light Navy', group: 'Primary' },
    { key: '2', value: namedColor.red, title: 'Error red', group: 'Status' },
    { key: '3', value: namedColor.green, title: 'Success green', group: 'Status' },
    { key: '4', value: namedColor.lines, title: 'Lines', group: 'Lines & borders' },
    { key: '5', value: namedColor.background, title: 'Background', group: 'Backgrounds' },
    { key: '51', value: namedColor.lightBackground, title: 'Light background', group: 'Backgrounds' },
    { key: '52', value: namedColor.ice, title: 'Ice', group: 'Backgrounds' },
    { key: '6', value: namedColor.aqua, title: 'Aqua', group: 'Brand' },
    { key: '61', value: namedColor.aquaGradient, title: 'Aqua Gradient', group: 'Brand' },
    { key: '62', value: namedColor.yellow, title: 'Yellow', group: 'Brand' },
    { key: '63', value: namedColor.yellowTint, title: 'Yellow Tint', group: 'Brand' },
    { key: 'w', value: 'white', title: 'White', group: 'White' },
    { key: 't', value: 'transparent', title: 'Transparent', group: 'System' }
];
exports.color = color;
